import { Button } from "@mui/material";

const ActionButton = ({
  condition,
  disabled,
  variant,
  color,
  className,
  text,
  icon,
  endIcon,
  size,
  onClick,
}) => {
  return (
    condition && (
      <Button
        disabled={disabled}
        variant={variant}
        size={size || "small"}
        color={color}
        className={className}
        style={{ textTransform: "none" }}
        startIcon={
          icon && <span className="material-icons-outlined">{icon}</span>
        }
        endIcon={
          endIcon && <span className="material-icons-outlined">{endIcon}</span>
        }
        onClick={onClick}
      >
        {text}
      </Button>
    )
  );
};
export default ActionButton;
